import { render, staticRenderFns } from "./CiSpecsTable.vue?vue&type=template&id=86f1700c&"
import script from "./CiSpecsTable.vue?vue&type=script&lang=js&"
export * from "./CiSpecsTable.vue?vue&type=script&lang=js&"
import style0 from "./CiSpecsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports